'use client';

import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { DropdownMenu, DropdownMenuItem } from '@repo/design-system/components/ui/dropdown-menu';
import { Type } from '@repo/design-system/components/ui/type';
import { useCurrentLanguage } from '@repo/i18n/hooks/use-current-language';
import { type LanguageCode, languageMap } from '@repo/i18n/i18n-resources/languages';
import { css } from '@repo/panda/css';
import { useEffect, useState } from 'react';
import { getLocalizedCurrentPath } from '../utils/localized-current-path';
export const MobileLanguageSelector = () => {
  const $ = _c(11);
  const currentLanguage = useCurrentLanguage();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      minWidth: "[48px]",
      width: "[48px]",
      minHeight: "[48px]",
      height: "[48px]",
      maxHeight: "[48px]",
      borderRadius: "full",
      flexShrink: 0,
      backgroundColor: "whiteAlpha.20",
      padding: "0"
    });
    t3 = <Icon icon="language" decorative={true} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <IconButton variant="ghost" color="primary" size="sm" aria-label="Change language" className={t2}>{t3}</IconButton>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentLanguage) {
    t5 = Object.entries(languageMap).map(t6 => {
      const [langCode, langInfo] = t6;
      return <DropdownMenuItem key={langCode} value={langCode} asChild={true}><a onKeyDown={e => {
          if (e.key === "Enter") {
            if (currentLanguage === langCode) {
              return;
            }
            const path = getLocalizedCurrentPath(langCode as LanguageCode, currentLanguage);
            if (path) {
              window.location.href = path;
            }
          }
        }} href={getLocalizedCurrentPath(langCode as LanguageCode, currentLanguage)} className={css({
          pointerEvents: currentLanguage === langCode ? "none" : "auto",
          textDecoration: "none",
          display: "flex",
          padding: "8",
          flexDirection: "row",
          gap: "8",
          alignItems: "center",
          borderRadius: "6",
          "&:hover": {
            backgroundColor: "whiteAlpha.10"
          },
          "&:focus-visible": {
            backgroundColor: "whiteAlpha.10"
          }
        })}>{currentLanguage === langCode && <Icon className={css({
            marginRight: "4"
          })} icon="check" size="sm" decorative={true} />}<div className={css({
            display: "flex",
            flexDirection: "column"
          })}><Type variant="header-s" as="span"><span>{langInfo.native}</span></Type><Type variant="caption" color="text.secondary" as="span">{langInfo.name}</Type></div></a></DropdownMenuItem>;
    });
    $[6] = currentLanguage;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <DropdownMenu size="sm" variant="dark" placement="bottom-end" trigger={t4}>{t5}</DropdownMenu>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};